// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radiokt-container[data-v-c35101fa]{height:100%;background-color:var(--111111);overflow:auto}.radio-event-box[data-v-c35101fa]{max-width:768px;width:100%;margin:0 auto}", ""]);
// Exports
module.exports = exports;
